export default "__VITE_ASSET__2ANLsDJv__"